<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div>
              <h4 class="mb-12 mb-md-0"></h4>
            </div>

            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-header">
                  <h4 style="margin-right: 5px" class="float-start">
                    {{ $t("cml_tariff_master") }}
                  </h4>
                  <button v-if="permision_role.method_create" class="btn btn-primary float-end btn-xs"
                    style="margin-right: 5px" @click.prevent="createData()">
                    <i class="link-icon mdi mdi-plus"></i>
                    {{ $t("createNew") }}
                  </button>

                  <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs"
                    style="margin-right: 5px" @click.prevent="downloadData()">
                    <i class="link-icon mdi mdi-download"></i>
                    {{ $t("downloadData") }} .xlsx
                  </button>
                  <button v-if="permision_role.method_read" class="btn btn-dark float-end btn-xs"
                    style="margin-right: 5px" @click="massUploadTariffMaster()" type="button">
                    <i class="link-icon mdi mdi-upload"></i>
                    {{ $t("massUploadTariffMaster") }} .xlsx
                  </button>
                </div>

                <div class="card-body">
                  <vue-good-table title="list-billing-tarif-master-cml" ref="list-billing-tarif-master-cml"
                    :select-options="{
                      enabled: false,
                      selectOnCheckboxOnly: true,
                      selectionText: $t('data_selected'),
                      clearSelectionText: $t('clear'),
                    }" mode="remote" @on-selected-rows-change="selectionChanged" @on-page-change="onPageChange"
                    @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :line-numbers="true"
                    :isLoading.sync="isLoading" :pagination-options="{
                      enabled: true,
                      perPageDropdown: [10, 50, 100, 1000, 10000],
                      dropdownAllowAll: false,
                    }" :rows="rows" :columns="columns">
                    <div slot="selected-row-actions">
                      <button v-if="permision_role.method_delete" class="btn btn-danger btn-xs"
                        style="margin-right: 20px" @click="deleteMass">
                        <i class="mdi mdi-send-outline"></i>
                        {{ $t("DeleteTxt") }}
                      </button>

                      <button class="btn btn-success btn-xs" @click="removeOrderHeaderIds">
                        <i class="mdi mdi-close"></i>
                        {{ $t("cancel_order_txt") }}
                      </button>
                    </div>

                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'actions'">
                        <a href="#" v-if="permision_role.method_read" title="Detail"
                          @click.prevent="detailData(props.index, props.row)">
                          <i class="mdi mdi-eye" style="font-size: 16px"></i>
                        </a>
                        <a href="#" v-if="permision_role.method_update" title="Edit"
                          @click.prevent="editData(props.index, props.row)">
                          <i class="mdi mdi-square-edit-outline" style="font-size: 16px"></i>
                        </a>

                        <a href="#" v-if="
                          permision_role.method_delete &&
                          props.row.status == 'DEACTIVE'
                        " title="Delete" @click.prevent="deleteData(props.index, props.row)">
                          <i class="mdi mdi-trash-can-outline" style="font-size: 16px"></i>
                        </a>
                      </span>

                      <span v-else-if="props.column.field == 'status'">
                        <span v-if="props.row.status == 'ACTIVE'" class="badge bg-info">
                          <h5>{{ props.row.status }}</h5>
                        </span>
                        <span v-else class="badge bg-secondary">
                          <h5>{{ props.row.status }}</h5>
                        </span>
                      </span>

                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::modal-->
        <modal name="massUploadTariffMaster" :draggable="false" :scrollable="true" :height="'auto'">
          <div class="modal fade show" tabindex="-1" style="display: block; margin-top: 2%" aria-modal="true"
            role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-xl">
              <div class="modal-content">
                <form class="forms-sample" @submit.prevent="submitMassUploadTariffMaster" method="POST">
                  <div class="modal-header">
                    <h5 class="modal-title" id="massUploadTariffMaster">
                      {{ this.$t("massUploadTariffMaster") }}
                    </h5>
                    <button type="button" class="btn-close" aria-label="btn-close"
                      @click.prevent="removeModals()"></button>
                  </div>
                  <div class="modal-body">
                    <div class="mb-3">
                      <label for="files" class="form-label">{{ this.$t("file") }}:</label>
                      <input type="file" class="form-control" ref="fileMassUploadTariffMaster"
                        @change="handleFileMassUploadTariffMaster($event)" required />

                      <div v-if="errors.file_data_tariff_master">
                        <div v-for="error in errors.file_data_tariff_master" :key="error" class="alert alert-primary"
                          role="alert">
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                    <div class="mb-3">
                      <br />
                      <label for="downloadTemplateTariffMaster" class="form-label">
                        <a @click="downloadTemplateTariffMaster()" style="color: #6571ff; text-decoration: none">
                          {{ this.$t("downloadTemplateTariffMaster") }}
                        </a>
                      </label>
                    </div>
                    <div class="mb-3" v-if="errorsDataTariffMasterUpload">
                      <div class="table-responsive">
                        <table class="table table-hover">
                          <thead>
                            <th>{{ $t("lineNo") }}</th>
                            <th>{{ $t("statusTxt") }}</th>
                            <th>{{ $t("messageTxt") }}</th>
                          </thead>
                          <tbody>
                            <tr v-for="(
                                errorsDataTariffMaster, index
                              ) in errorsDataTariffMasterUpload" :key="index">
                              <th>{{ errorsDataTariffMaster.No }}</th>
                              <th>{{ errorsDataTariffMaster.status }}</th>
                              <th>{{ errorsDataTariffMaster.message }}</th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">
                      {{ this.$t("close_txt") }}
                    </button>
                    <button type="submit" class="btn btn-primary">
                      {{ this.$t("UploadTxt") }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </modal>
        <!--end::modal-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "CmlTarifIndex",
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      isLoading: false,
      errors: [],
      permision_role: [],
      langs: ["id", "en"],
      detailUser: [],
      idTarifMasterHeaders: [],
      detailDivisi: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      columns: [
        {
          label: this.$t("action_txt"),
          field: "actions",
          thClass: "text-center",
          sortable: false,
        },
        {
          label: this.$t("idTarifMasterHeader"),
          field: "idTarifMasterHeader",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: this.$t("idTarifMasterHeader"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("customerId"),
          field: "customerId",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: this.$t("customerId"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("tarifMasterId"),
          field: "tarifMasterId",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: this.$t("tarifMasterId"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("multi_warehouse_flag"),
          field: "multiWhFlag",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "All", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ["Y", "N"], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("beginningBalanceFlag"),
          field: "beginningBalanceFlag",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "All", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ["Y", "N"], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("begBalRentPallFlag"),
          field: "begBalRentPallFlag",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "All", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ["Y", "N"], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("weeklyTransmitFlag"),
          field: "weeklyTransmitFlag",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "All", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ["Y", "N"], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("statusTxt"),
          field: "status",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "All", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ["ACTIVE", "DEACTIVE"], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
      ],
      rows: [],
      rowsSelection: [],
      fileMassUploadTariffMaster: "",
      errorsDataTariffMasterUpload: false,
    };
  },
  watch: {},
  methods: {
    handleFileMassUploadTariffMaster(event) {
      this.fileMassUploadTariffMaster = event.target.files[0];
    },

    massUploadTariffMaster() {
      this.$modal.show("massUploadTariffMaster");
    },

    removeModals() {
      this.$modal.hide("massUploadTariffMaster");
      this.fileMassUploadTariffMaster = "";
      this.errorsDataTariffMasterUpload = false;
    },

    resetForm() {
      this.fileMassUploadTariffMaster = "";
    },

    downloadTemplateTariffMaster() {
      this.isLoading = true;
      //var params = this.$onBehind(this.$route.params.id);
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/bm-tarif-master-cml?download=downloadTemplate";
      var file_name = "billing-module-cml-template-tariff-master.xlsx";

      return this.$http
        .get(
          baseURI +
          `?sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&customerId=${this.serverParams.columnFilters.customerId}&rateBaseDesc=${this.serverParams.columnFilters.rateBaseDesc}&tarifMasterId=${this.serverParams.columnFilters.tarifMasterId}&status=${this.serverParams.columnFilters.status}&multiWhFlag=${this.serverParams.columnFilters.multiWhFlag}&weeklyTransmitFlag=${this.serverParams.columnFilters.weeklyTransmitFlag}&beginningBalanceFlag=${this.serverParams.columnFilters.beginningBalanceFlag}&begBalRentPallFlag=${this.serverParams.columnFilters.begBalRentPallFlag}&download=downloadTemplate`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.isLoading = false;
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    submitMassUploadTariffMaster() {
      this.isLoading = true;

      let formData = new FormData();
      formData.append("file", this.fileMassUploadTariffMaster);

      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/bm-tarif-master-cml/mass-upload-tariff-master";
      this.$http
        .post(baseURI, formData)
        .then((response) => {
          this.isLoading = false;
          this.errorsDataTariffMasterUpload = response.data.datas;
          this.resetForm();
        })
        .catch((error) => {
          this.loading();

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errorsDataTariffMasterUpload = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    selectionChanged(ev) {
      this.rowsSelection = [];
      this.idTarifMasterHeaders = [];
      this.rowsSelection = ev.selectedRows;

      this.rowsSelection.forEach((item) => {
        this.idTarifMasterHeaders.push(item.idTarifMasterHeader);
      });
    },

    deleteMass() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          //this.loadingSubmiting();
          this.loading();
          let data = {
            idTarifMasterHeaders: this.idTarifMasterHeaders,
          };
          const baseURI =
            this.$settings.endPointBilling +
            "dashboard/cml-billing/bm-tarif-master-cml/delete-mass";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              //this.loading();
              this.success(response.data.datas.messages);
              this.idTarifMasterHeader = [];
              this.loadItems();
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    removeOrderHeaderIds() {
      this.idTarifMasterHeader = [];
      this.$refs["list-billing-tarif-master-cml"].unselectAllInternal();
    },

    downloadData() {
      this.isLoading = true;
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/bm-tarif-master-cml";
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      return this.$http
        .get(
          baseURI +
          `?sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&customerId=${this.serverParams.columnFilters.customerId}&rateBaseDesc=${this.serverParams.columnFilters.rateBaseDesc}&tarifMasterId=${this.serverParams.columnFilters.tarifMasterId}&status=${this.serverParams.columnFilters.status}&multiWhFlag=${this.serverParams.columnFilters.multiWhFlag}&idTarifMasterHeader=${this.serverParams.columnFilters.idTarifMasterHeader}&beginningBalanceFlag=${this.serverParams.columnFilters.beginningBalanceFlag}&begBalRentPallFlag=${this.serverParams.columnFilters.begBalRentPallFlag}&weeklyTransmitFlag=${this.serverParams.columnFilters.weeklyTransmitFlag}&download=download`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.isLoading = false;
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    createData() {
      this.isLoading = true;
      window.location.href = "/billing-cml/master-tarif/create";
    },

    editData(index, row) {
      this.isLoading = true;
      var params = this.$onRandom(row.idTarifMasterHeader);
      window.location.href = "/billing-cml/master-tarif/edit/" + params;
    },

    detailData(index, row) {
      this.isLoading = true;
      var params = this.$onRandom(row.idTarifMasterHeader);
      window.location.href = "/billing-cml/master-tarif/detail/" + params;
    },

    deleteData(index, row, status) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            status: status,
          };
          const baseURI =
            this.$settings.endPointBilling +
            "dashboard/cml-billing/bm-tarif-master-cml/delete/" +
            row.idTarifMasterHeader;
          this.$http
            .delete(baseURI, formData, { timeout: 60000 })
            .then((response) => {
              this.loading();
              this.isLoading = false;
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));
                } else {
                  if (error.response) {
                    if (error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                      this.logout();
                    } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                      this.$router.push("/server-error");
                    } else {
                      this.$router.push("/page-not-found");
                    }
                  }
                }
              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    // load items is what brings back the rows from server
    loadItems() {
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/bm-tarif-master-cml";
      this.isLoading = true;

      return this.$http
        .get(
          baseURI +
          `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&customerId=${this.serverParams.columnFilters.customerId}&tarifMasterId=${this.serverParams.columnFilters.tarifMasterId}&status=${this.serverParams.columnFilters.status}&multiWhFlag=${this.serverParams.columnFilters.multiWhFlag}&idTarifMasterHeader=${this.serverParams.columnFilters.idTarifMasterHeader}&beginningBalanceFlag=${this.serverParams.columnFilters.beginningBalanceFlag}&begBalRentPallFlag=${this.serverParams.columnFilters.begBalRentPallFlag}&weeklyTransmitFlag=${this.serverParams.columnFilters.weeklyTransmitFlag}`,
          { timeout: 60000 }
        )
        .then((response) => {
          this.isLoading = false;
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
        })
        .catch((error) => {
          this.loading();

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (
          permision.permission.controller == "BmTarifMasterHeaderController"
        ) {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },
  },
  events: {},
  created: function () { },
  mounted() {
    this.fetchIt();
    this.loading();
  },
};
</script>
<style scoped>
.blur-content {
  filter: blur(5px);
}
</style>
